<app-modal style="height:100%">
  <ng-container modal-header>
    <ion-label slot="start">Activity Details</ion-label>
  </ng-container>
  <ng-container modal-body>
    <form #form="ngForm" (ngSubmit)="save()" >
      <ion-item>
        <ion-label>Title</ion-label>
        <ion-input type="text" [(ngModel)]="activity.name" name="name" placeholder="Type a title" required></ion-input>
      </ion-item>
      <ion-item>
        <ion-label>Type</ion-label>
        <ion-select [(ngModel)]="activity.type" name="type" placeholder="Select an activity type" required>
          <ion-select-option *ngFor="let option of options" [value]="option">{{option}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label>Date & time {{ activity.start_date_local | date: 'mediumDate' }}</ion-label>
        <ion-input hidden [(ngModel)]="activity.start_date_local" name="start_date_local"></ion-input>
        <ion-button id="open-date-input-2" color="light" style="position: absolute;right: 5vw;"item-end>
          <ion-icon icon="calendar"></ion-icon>
        </ion-button>
        <ion-popover trigger="open-date-input-2" show-backdrop="false" >
          <ng-template>
            <ion-datetime hourCycle="h23"
              #popoverDatetime2 name="start_date_local"
               (ionChange)="setDate(popoverDatetime2.value)"
            ></ion-datetime>
          </ng-template>
        </ion-popover>
      </ion-item>
      <ion-item>
        <ion-label>Duration (hh:mm:ss)</ion-label>
        <ion-button id="open-date-input-2" color="light" style="position: absolute;right: 5vw;" (click)="openPicker()" item-end>
          {{activity.moving_time | elapsed}}
        </ion-button>
        <!--ion-input (ionChange)="calculate()" [(ngModel)]="hours" type="number" min="0" max="99" name="hours" placeholder="00" required></ion-input>
        :
        <ion-input (ionChange)="calculate()" [(ngModel)]="minutes" type="number" min="0" max="59" name="minutes" placeholder="00" required></ion-input>
        :
        <ion-input (ionChange)="calculate()" [(ngModel)]="seconds" type="number" min="0" max="59" name="seconds" placeholder="00"required></ion-input-->

      </ion-item>
      <ion-item>
        <ion-label>Distance (m)</ion-label>
        <ion-input type="number"  (ionChange)="calculate(activity.distance)" [(ngModel)]="activity.distance" name="distance" required></ion-input>
      </ion-item>
      <!--pre>{{activity | json}}</pre-->
    </form>
    <ion-item lines="full">
      <ion-label>Sample</ion-label>
    </ion-item>
    <div class="garminCircles">
      <app-garmin-box [activity]="activity"></app-garmin-box>
    </div>
  </ng-container>
  <ng-container modal-footer>
    <ion-button slot="start" [disabled]="!form.valid || activity.moving_time === 0" (click)="save()">
      Save <ion-icon name="save"></ion-icon>
    </ion-button>
    <ion-button color="dark"  slot="end" (click)="dismiss(null)">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </ng-container>

</app-modal>
